module.exports = __webpack_public_path__ + "static/img/1.9ebf80a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/4/1.png
// module id = 3od+
// module chunks = 2